import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { db, collection, addDoc, Timestamp } from '@/firebase';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Send, FileText } from 'lucide-react';

export default function RequestDocumentForm({ onSuccess }: { onSuccess: () => void }) {
  const { user } = useAuth();
  const [subject, setSubject] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!user) return;
    setIsSubmitting(true);
    try {
      await addDoc(collection(db, 'requests'), {
        userId: user.uid,
        subject,
        description,
        status: 'pending',
        createdAt: Timestamp.now()
      });
      toast.success("Permintaan dokumen berhasil dikirim!");
      setSubject('');
      setDescription('');
      onSuccess();
    } catch (error) {
      console.error('Submit request error:', error);
      toast.error("Gagal mengirim permintaan.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="subject" className="font-semibold text-foreground">Subjek Dokumen</Label>
        <Input 
          id="subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          required
          className="border-foreground/10"
          placeholder="Contoh: Dokumen RAB untuk Proyek Jalan"
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="description" className="font-semibold text-foreground">Deskripsi Kebutuhan</Label>
        <textarea 
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
          className="w-full min-h-[120px] p-3 rounded-lg border border-foreground/10 focus:border-primary outline-none text-sm bg-card text-foreground"
          placeholder="Jelaskan detail dokumen yang Anda butuhkan..."
        />
      </div>
      <Button 
        type="submit" 
        disabled={isSubmitting}
        className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-bold rounded-xl"
      >
        {isSubmitting ? "Mengirim..." : (
          <>
            <Send className="h-4 w-4 mr-2" /> Kirim Permintaan
          </>
        )}
      </Button>
    </form>
  );
}
